import React, { useState } from "react";
import "./services.css"

const Services = () => {
   const [toggleState, setToggleState] = useState(0);

   const toggleTab = (index) => {                                          // Toggle effect
      setToggleState(index);
   }

   return(
      <section className="services section" id="services">
         <h2 className="section__title">Projects</h2>
         <span className="section__subtitle">What I've built</span>

         <div className="services__container container grid">
            <div className="services__content">
               <div>
                  <i className="uil uil-web-grid services__icon"></i>
                  <h3 className="services__title">
                     Company <br/> Projects
                  </h3>
               </div>

               <span onClick={() => toggleTab(1)} className="services__button">View More                          {/*View popup*/}
                  <i className="uil uil-arrow-right services__button-icon"></i>
               </span>

               <div className={(toggleState === 1) ? "services__modal active-modal" : "services__modal"}>         {/*Popup Card*/}
                  <div className="services__modal-content">
                     <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>         {/*Close effect*/}

                     <h3 className="services__modal-title">
                        Experiment Analysis App
                     </h3>
                     <p className="services__modal-description">
                        More projects with a detailed write up can be found in my resume.
                     </p>

                     <ul className="services__modal-services grid">
                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info">
                              Automated the testing teams workflows from 45 minutes down to 10 seconds.
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info">
                              Created algorithms that predicted performance degradations over time and made alterations.
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Functionality that auto-updated and backed-up the MongoDB database, real-time, based on user
                              interactions for each experiment run.
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info">
                              Programmed automation backup scripts to query the databases and take regular daily backup to server as restore points.
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Demonstrated to the company over various sprints, the effective usage of the applications.
                           </p>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>

            <div className="services__content">
               <div>
                  <i className="uil uil-arrow services__icon"></i>
                  <h3 className="services__title">
                     Personal <br/> Projects
                  </h3>
               </div>

               <span onClick={() => toggleTab(2)} className="services__button">View More                         {/*View popup*/}
                  <i className="uil uil-arrow-right services__button-icon"></i>      
               </span>

               <div className={(toggleState === 2) ? "services__modal active-modal" : "services__modal"}>        {/*Popup Card*/}
                  <div className="services__modal-content">
                     <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>        {/*Close effect*/}

                     <h3 className="services__modal-title">Personal Projects</h3>
                     <p className="services__modal-description">
                        More projects with a detailed write up can be found in my resume as well as GitHub portfolio - 
                        <a href="https://github.com/StuartDaniells" target="_blank" rel="noreferrer">
                           <i className="bx bxl-github" 
                              style= {   
                                       {backgroundColor:"var(--title-color)",
                                       color: "var(--container-color)",
                                       fontSize: "1.125rem",
                                       padding: "0.4rem",
                                       borderRadius: "0.5rem",
                                       display: "inlineFlex"
                                       }}>
                                 
                           </i>
                        </a>
                     </p>

                     <ul className="services__modal-services grid">
                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> Face recognition Web App & API. </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> Smart Mirror - Voice Automated - Integrated with open sourced Alexa.</p>
                        </li>


                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Incorporated the latest web tech. tools to build a 2 tier Web app
                              <a href="https://github.com/StuartDaniells/Robo_People" 
                                 className="services__modal-info"
                                 target="_blank" rel="noreferrer"> 
                                 - Robo People 
                              </a>
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Detailed weather app GUI with Python libraries
                              <a href="https://github.com/StuartDaniells/Detailed_Weather_App_GUI" 
                                 className="services__modal-info"
                                 target="_blank" rel="noreferrer"> 
                                 - Weather App GUI
                              </a>
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Something fun to get familiar with CSS
                              <a href="https://stuartdaniells.github.io/" 
                                 className="services__modal-info"
                                 target="_blank" rel="noreferrer"> 
                                 - Dancing Robot 
                              </a>
                           </p>
                        </li>

                     </ul>
                  </div>
               </div>
            </div>

            <div className="services__content">
               <div>
                  <i className="uil uil-edit services__icon"></i>
                  <h3 className="services__title">
                     College/University <br/> Projects
                  </h3>
               </div>

               <span onClick={() => toggleTab(3)} className="services__button">View More                          {/*View popup*/}
                  <i className="uil uil-arrow-right services__button-icon"></i>
               </span>

               <div className={(toggleState === 3) ? "services__modal active-modal" : "services__modal"}>         {/*Popup Card*/}
                  <div className="services__modal-content">
                     <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>         {/*Close effect*/}

                     <h3 className="services__modal-title">College/University Projects</h3>
                     <p className="services__modal-description">
                        More projects with a detailed write up can be found in my resume as well as GitHub portfolio - 
                        <a href="https://github.com/StuartDaniells" target="_blank" rel="noreferrer">
                           <i className="bx bxl-github" 
                              style= {   
                                       {backgroundColor:"var(--title-color)",
                                       color: "var(--container-color)",
                                       fontSize: "1.125rem",
                                       padding: "0.4rem",
                                       borderRadius: "0.5rem",
                                       display: "inlineFlex"
                                    }}>
                           </i>
                        </a>
                     </p>

                     <ul className="services__modal-services grid">
                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Professional company product website with presentation
                              <a href="https://youtu.be/jKABWf9iFgQ" 
                                 className="services__modal-info"
                                 target="_blank" rel="noreferrer"> 
                                 - YouTube Presentation 
                              </a>
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info">
                              Project Management courses curriculum website
                              <a href="https://stuartdaniells.github.io/project_management/index.html" 
                                 className="services__modal-info"
                                 target="_blank" rel="noreferrer"> 
                                 - Website
                              </a>
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Smart Mirror - Voice Automated - Integrated with open sourced Alexa.
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> 
                              Built a fullfledged 3-tier Web Application incorporating technologies like:
                              <p>AWS EC2 instance, MongoDB, React, SateManagement, Routing, Node.js & Express.js, Ajax, Linux, etc.</p>
                           </p>
                        </li>

                        <li className="services__modal-service">
                           <i className="uil uil-check-circle services__modal-icon"></i>
                           <p className="services__modal-info"> Quantum levitation using a superconductor - YBCO</p>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default Services;